import loadScript from 'load-script-once';
import { bugsnagLeaveBreadcrumb, bugsnagNotify } from './bugsnag';

const { recaptchaPublicKey } = window.beagly;

export const SURVEY_INIT_ACTION = 'survey';

const init = async () => {
  if (window.grecaptcha) {
    await new Promise(window.grecaptcha.ready);
    return;
  }
  await new Promise((resolve, reject) => {
    window.grecaptcha = {
      ready() {
        resolve();
        bugsnagLeaveBreadcrumb('Recaptcha script loaded');
      },
    };
    window.recaptchaOnloadCallback = window.grecaptcha.ready;
    loadScript(
      `https://www.recaptcha.net/recaptcha/api.js?onload=recaptchaOnloadCallback&render=${recaptchaPublicKey}`,
    ).catch(reject);
  });
};

export const recaptchaTokenize = async (action) => {
  if (!recaptchaPublicKey) return null;
  try {
    await init();
    const token = await window.grecaptcha.execute(recaptchaPublicKey, { action });
    return token;
  } catch (error) {
    bugsnagLeaveBreadcrumb('Recaptcha error', { action });
    bugsnagNotify(error);
    return null;
  }
};
